/* Shampoo & Conditioner landing (templates/page.shampoo-conditioner.json), ported from the 2026-10-09 Netlify export. */
(function () {
  'use strict';

  var inits = {};
  var cleanups = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function lifecycle() {
    var undo = [];
    return {
      on: function (target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        undo.push(function () { target.removeEventListener(type, fn, opts); });
      },
      observe: function (observer, el) {
        observer.observe(el);
        undo.push(function () { observer.disconnect(); });
        return observer;
      },
      timer: function (id) {
        undo.push(function () { clearTimeout(id); });
        return id;
      },
      add: function (fn) {
        undo.push(fn);
      },
      done: function () {
        undo.splice(0).forEach(function (fn) { fn(); });
      }
    };
  }

  // Export app.js: .reveal fade-in once, IntersectionObserver; the hidden state needs .motion-ready on an ancestor.
  function reveal(root, lc) {
    if (!('IntersectionObserver' in window) || reduced.matches) return;
    var items = root.querySelectorAll('.reveal');
    if (!items.length) return;
    root.classList.add('motion-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
    lc.add(function () { io.disconnect(); });
  }

  function start(root) {
    var init = inits[root.getAttribute('data-sc-section')] || function () {};
    if (cleanups.has(root)) return;
    var lc = lifecycle();
    if (root.querySelectorAll) reveal(root, lc);
    var cleanup = init(root) || function () {};
    cleanups.set(root, function () { lc.done(); cleanup(); });
  }

  function stop(root) {
    var cleanup = cleanups.get(root);
    if (!cleanup) return;
    cleanups.delete(root);
    cleanup();
  }

  function startAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sc-section]'), start);
  }

  document.addEventListener('shopify:section:load', function (e) { startAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-sc-section]'), stop);
  });

  // Export hero-video.js: autoplay muted loop, pause off-screen; reduced motion = poster only, sources removed.
  inits.hero = function (root) {
    var lc = lifecycle();
    var v = root.querySelector('.hx-video');
    if (!v) return lc.done;
    v.muted = true;
    var srcs = Array.prototype.map.call(v.querySelectorAll('source'), function (s) { return s.cloneNode(); });
    var visible = true;
    var play = function () {
      if (reduced.matches || !visible || document.hidden) return;
      var p = v.play();
      if (p) p.catch(function () {});
    };
    var still = function () {
      v.pause(); v.removeAttribute('autoplay'); v.preload = 'none';
      Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) { s.remove(); });
      v.load();
    };
    var live = function () {
      if (!v.querySelector('source')) {
        srcs.forEach(function (s) { v.appendChild(s.cloneNode()); });
        v.preload = 'auto'; v.load();
      }
      play();
    };
    if (reduced.matches) still();
    if ('IntersectionObserver' in window) {
      lc.observe(new IntersectionObserver(function (es) {
        visible = es[es.length - 1].isIntersecting;
        if (visible) play(); else v.pause();
      }, { threshold: 0 }), root);
    }
    lc.on(reduced, 'change', function () { if (reduced.matches) still(); else live(); });
    play();
    return lc.done;
  };

  // Export follicle-film.js: native loop while >=40% visible, rewind after fully leaving; reduced motion,
  // no IntersectionObserver, blocked autoplay or error = .is-still end frame.
  inits['peptide-complex'] = function (root) {
    var lc = lifecycle();
    var box = root.querySelector('.pcw-media');
    var v = root.querySelector('.pcw-video');
    if (!box || !v) return lc.done;
    v.loop = true; v.muted = true; v.controls = false;
    var posterD = v.getAttribute('poster') || '';
    var mq = window.matchMedia('(max-width:1023px)');
    var poster = function () { v.poster = mq.matches ? (v.dataset.posterM || posterD) : posterD; };
    poster();
    lc.on(mq, 'change', poster);
    var still = function () { box.classList.add('is-still'); v.pause(); v.preload = 'none'; };
    if (reduced.matches || !('IntersectionObserver' in window)) { still(); return lc.done; }
    var state = 'idle';
    var rewind = function () { try { v.currentTime = 0; } catch (_) {} };
    var play = function () {
      var p = v.play();
      if (p) p.catch(function (e) { if (e && e.name === 'NotAllowedError') still(); });
    };
    // A <source> skipped by its media query fires error too; fall back only on a media error or with no source left.
    lc.on(v, 'error', function (e) {
      if (e.target === v || v.networkState === v.NETWORK_NO_SOURCE) still();
    }, true);
    lc.on(reduced, 'change', function () { if (reduced.matches) still(); });
    var near = lc.observe(new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { v.preload = 'auto'; near.disconnect(); }
    }, { rootMargin: '400px 0px' }), box);
    lc.observe(new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (box.classList.contains('is-still')) return;
        if (e.intersectionRatio >= 0.4 && state === 'idle') { state = 'playing'; rewind(); play(); }
        else if (!e.isIntersecting && state !== 'idle') { state = 'idle'; v.pause(); rewind(); }
      });
    }, { threshold: [0, 0.4] }), box);
    return lc.done;
  };

  // Export bubbles.js: pause the floating drops (CSS + SMIL) while off-screen.
  inits['peptide-opener'] = function (root) {
    var lc = lifecycle();
    var w = root.querySelector('.pbx-drops');
    var svg = root.querySelector('.pbx-svg');
    if (!w || !('IntersectionObserver' in window)) return lc.done;
    var set = function (on) {
      w.classList.toggle('is-paused', !on);
      try { if (svg) { if (on) svg.unpauseAnimations(); else svg.pauseAnimations(); } } catch (e) {}
    };
    set(false);
    lc.observe(new IntersectionObserver(function (es) {
      es.forEach(function (en) { set(en.isIntersecting); });
    }, { rootMargin: '100px 0px' }), root);
    return lc.done;
  };

  // Export proof-count.js: odometer count-up from final-10 in 1.4s, figure fades in and rises 8px; plays on
  // each entry (>=40% visible), resets after fully leaving. Reduced motion: final value untouched.
  function countUp(root, lc) {
    var nums = Array.prototype.slice.call(root.querySelectorAll('.pv-num[data-final]'));
    if (!nums.length || reduced.matches || !('IntersectionObserver' in window)) return;
    var measure = [];
    nums.forEach(function (el) {
      var fin = +el.dataset.final;
      var start = Math.max(0, fin - 10);
      var DUR = 1400;
      var EASE = 'cubic-bezier(.22,1,.36,1)';
      var fade = el.closest('.pv-fig');
      var delay = +(el.dataset.delay || 0);
      var fs = String(fin);
      el.textContent = '';
      var cols = [];
      for (var i = 0; i < fs.length; i++) {
        var seq = [];
        for (var v = start; v <= fin; v++) seq.push(String(v).padStart(fs.length, '0')[i]);
        var slot = document.createElement('span'); slot.className = 'pv-slot';
        var col = document.createElement('span'); col.className = 'pv-col';
        var vals = seq.filter(function (x, j) { return j === 0 || x !== seq[j - 1]; });
        col.innerHTML = vals.map(function (x) { return '<span>' + x + '</span>'; }).join('');
        slot.appendChild(col); el.appendChild(slot);
        cols.push({ col: col, n: vals.length });
      }
      var anim = [];
      var state = 'idle';
      var reset = function () {
        anim.forEach(function (a) { a.cancel(); }); anim = [];
        cols.forEach(function (c) { c.col.style.transform = 'translateY(0)'; });
        if (fade) fade.style.opacity = '0';
        state = 'idle';
      };
      var play = function () {
        if (state !== 'idle') return;
        state = 'played';
        anim = cols.filter(function (c) { return c.n > 1; }).map(function (c) {
          return c.col.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-' + (c.n - 1) + 'em)' }], { duration: DUR, delay: delay, easing: EASE, fill: 'forwards' });
        });
        if (fade) anim.push(fade.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 500, delay: delay, easing: EASE, fill: 'forwards' }));
      };
      reset();
      measure.push(function () {
        var size = parseFloat(getComputedStyle(el).fontSize);
        Array.prototype.forEach.call(el.querySelectorAll('.pv-slot'), function (s) {
          var ds = s.querySelectorAll('.pv-col>span');
          var p = document.createElement('span');
          p.textContent = ds[ds.length - 1].textContent;
          p.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap';
          el.appendChild(p);
          var w = p.getBoundingClientRect().width;
          p.remove();
          if (w && size) s.style.width = (w / size).toFixed(4) + 'em';
        });
      });
      lc.observe(new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.intersectionRatio >= 0.4) play(); else if (!e.isIntersecting) reset(); });
      }, { threshold: [0, 0.4] }), el.closest('.pv-stat') || el);
    });
    var run = function () { measure.forEach(function (f) { f(); }); };
    var lastFs = nums.map(function (n) { return getComputedStyle(n).fontSize; }).join();
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(function () {
      run();
      lc.on(window, 'resize', function () {
        var fs = nums.map(function (n) { return getComputedStyle(n).fontSize; }).join();
        if (fs !== lastFs) { lastFs = fs; run(); }
      });
    });
  }

  // Export micrograph-compare.js: before/after slider driven by a range input and pointer drag.
  function micrograph(f, lc) {
    var r = f.querySelector('.mc-range');
    var tb = f.querySelector('.mc-tag--b');
    var ta = f.querySelector('.mc-tag--a');
    if (!r) return;
    var raf = 0; var next = 50; var drag = null;
    function apply() {
      raf = 0;
      f.style.setProperty('--pos', next + '%');
      if (tb) tb.style.opacity = next < 24 ? 0 : 1;
      if (ta) ta.style.opacity = next > 76 ? 0 : 1;
    }
    function set(v) {
      next = Math.max(0, Math.min(100, v));
      var rv = Math.round(next);
      if (+r.value !== rv) r.value = rv;
      if (!raf) raf = requestAnimationFrame(apply);
    }
    function fromX(x) {
      var b = f.getBoundingClientRect();
      if (b.width) set(Math.round((x - b.left) / b.width * 1000) / 10);
    }
    function end(e) { if (drag === e.pointerId) drag = null; }
    lc.on(r, 'input', function () { set(+r.value); });
    lc.on(f, 'pointerdown', function (e) {
      if (e.button > 0) return;
      drag = e.pointerId;
      try { f.setPointerCapture(e.pointerId); } catch (_) {}
      fromX(e.clientX);
    });
    lc.on(f, 'pointermove', function (e) { if (drag === e.pointerId) fromX(e.clientX); });
    lc.on(f, 'pointerup', end);
    lc.on(f, 'pointercancel', end);
    lc.on(f, 'lostpointercapture', end);
    set(+r.value || 50);
  }

  inits.proof = function (root) {
    var lc = lifecycle();
    countUp(root, lc);
    Array.prototype.forEach.call(root.querySelectorAll('.mc-frame'), function (f) { micrograph(f, lc); });
    return lc.done;
  };

  inits['consumer-results'] = function (root) {
    var lc = lifecycle();
    countUp(root, lc);
    return lc.done;
  };

  // Export app.js (#experience and #footer-video-banner videos): load within 400px, play while 25% visible,
  // pause otherwise. Reduced motion or Save-Data: never plays.
  function playWhenVisible(v, lc) {
    v.muted = true;
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    if (reduced.matches || saveData || !('IntersectionObserver' in window)) { v.pause(); return; }
    var near = false;
    lc.observe(new IntersectionObserver(function (es) {
      if (es[es.length - 1].isIntersecting && !near) { near = true; v.preload = 'auto'; v.load(); }
    }, { rootMargin: '400px 0px' }), v.parentElement);
    lc.observe(new IntersectionObserver(function (es) {
      if (es[es.length - 1].isIntersecting && !reduced.matches) { var q = v.play(); if (q) q.catch(function () {}); }
      else v.pause();
    }, { threshold: 0.25 }), v.parentElement);
    lc.on(reduced, 'change', function () { if (reduced.matches) v.pause(); });
  }

  inits['footer-video'] = function (root) {
    var lc = lifecycle();
    var v = root.querySelector('video');
    if (v) playWhenVisible(v, lc);
    return lc.done;
  };

  // Export lather-video.js: each card plays once per entry (>=40% visible), holds its last frame, resets after
  // fully leaving. Reduced motion / blocked autoplay: end-frame still.
  inits['scent-lather'] = function (root) {
    var lc = lifecycle();
    Array.prototype.forEach.call(root.querySelectorAll('.sl-media'), function (box) {
      var v = box.querySelector('.sl-video');
      if (!v) return;
      v.loop = false; v.removeAttribute('loop'); v.removeAttribute('autoplay'); v.muted = true; v.controls = false;
      var still = function () { box.classList.add('is-still'); v.pause(); v.preload = 'none'; };
      if (reduced.matches || !('IntersectionObserver' in window)) { still(); return; }
      var state = 'idle';
      var rewind = function () { try { v.currentTime = 0; } catch (_) {} };
      var play = function () {
        var p = v.play();
        if (p) p.catch(function (e) { if (e && e.name === 'NotAllowedError') still(); });
      };
      lc.on(v, 'ended', function () { state = 'done'; });
      lc.on(reduced, 'change', function () { if (reduced.matches) still(); });
      var near = lc.observe(new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { v.preload = 'auto'; near.disconnect(); }
      }, { rootMargin: '400px 0px' }), box);
      lc.observe(new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (box.classList.contains('is-still')) return;
          if (e.intersectionRatio >= 0.4 && state === 'idle') { state = 'playing'; rewind(); play(); }
          else if (!e.isIntersecting && state !== 'idle') { state = 'idle'; v.pause(); rewind(); }
        });
      }, { threshold: [0, 0.4] }), box);
    });
    return lc.done;
  };

  // Export wi-callouts.js: three columns from 1024px; Panthenol points to the bottle shoulder, Moringa to the jar
  // lid. Stacked below 1024px. Entrance sequence per entry (>=40%), resets after leaving; reduced motion = final.
  inits['deep-moisture'] = function (root) {
    var lc = lifecycle();
    var st = root.querySelector('#whats-inside .wi-stage');
    if (!st) return lc.done;
    var media = st.querySelector('.wi-media');
    var b = st.querySelector('.wi-p--b');
    var j = st.querySelector('.wi-p--j');
    if (!media || !b || !j) return lc.done;
    var items = Array.prototype.slice.call(st.querySelectorAll('.wi-item'));
    var dots = Array.prototype.slice.call(st.querySelectorAll('.wi-marker'));
    var lines = Array.prototype.slice.call(st.querySelectorAll('.wi-leader'));
    var A = [[b, 0.273, 0.34, 'l'], [j, 0.999, 0.14, 'r']];
    var PAD = 12;
    var MINC = 220;
    var clear = function () {
      st.classList.remove('wi-desk'); st.style.minHeight = ''; st.style.paddingTop = '';
      media.style.width = ''; media.style.removeProperty('--mw');
      items.concat(dots, lines).forEach(function (e) { e.removeAttribute('style'); });
    };
    var place = function (W, col, gap) {
      var mw = W - 2 * col - 2 * gap;
      if (mw < 160) return null;
      media.style.width = mw + 'px';
      media.style.setProperty('--mw', mw + 'px');
      var s = st.getBoundingClientRect();
      var m = media.getBoundingClientRect();
      var mx = m.left - s.left;
      var my = m.top - s.top;
      var out = [];
      A.forEach(function (a, i) {
        var img = a[0]; var fx = a[1]; var fy = a[2]; var side = a[3];
        var it = items[i];
        if (!it) return;
        var r = img.getBoundingClientRect();
        var left = side === 'l' ? mx - gap - col : mx + mw + gap;
        it.style.cssText = 'left:' + left + 'px;width:' + col + 'px;top:0';
        var nm = it.querySelector('.wi-name');
        var ch = nm.offsetTop + nm.offsetHeight / 2;
        var y = r.top - s.top + fy * r.height;
        var x = r.left - s.left + fx * r.width;
        var top = y - ch;
        it.style.top = top + 'px';
        out.push({ x: x, y: y, top: top, bot: top + it.offsetHeight, side: side, left: left });
      });
      return { mw: mw, mx: mx, my: my, out: out, mh: m.height, col: col, gap: gap };
    };
    var layout = function () {
      clear();
      if (window.innerWidth < 1024) return;
      st.classList.add('wi-desk');
      var W = st.clientWidth;
      var best = null;
      [40, 32, 24].some(function (g) {
        var q = place(W, Math.max(MINC, Math.round(W * 0.25)), Math.min(g, Math.round(W * 0.03) + 12));
        if (q) { best = q; return true; }
        return false;
      });
      if (!best) { clear(); return; }
      var top0 = Math.min.apply(Math, [0].concat(best.out.map(function (o) { return o.top; })));
      if (top0 < 0) { st.style.paddingTop = Math.ceil(-top0) + 'px'; best = place(W, best.col, best.gap); }
      best.out.forEach(function (o, i) {
        dots[i].style.cssText = 'left:' + (o.x - best.mx) + 'px;top:' + (o.y - best.my) + 'px';
        var x1 = o.side === 'l' ? o.left + best.col + PAD : o.x;
        var x2 = o.side === 'l' ? o.x : o.left - PAD;
        lines[i].style.cssText = 'left:' + (x1 - best.mx) + 'px;top:' + (Math.round(o.y - best.my) - 0.5) + 'px;width:' + Math.max(0, x2 - x1) + 'px';
      });
      var bot = Math.max.apply(Math, [best.my + best.mh].concat(best.out.map(function (o) { return o.bot; })));
      st.style.minHeight = Math.ceil(bot + 8) + 'px';
    };
    var raf = 0;
    var busy = false;
    var sched = function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { busy = true; layout(); requestAnimationFrame(function () { busy = false; }); });
    };
    layout();
    [b, j].forEach(function (i) { if (!i.complete) lc.on(i, 'load', sched); });
    if (document.fonts) document.fonts.ready.then(sched);
    var lw = window.innerWidth;
    lc.on(window, 'resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; sched(); } });
    if ('ResizeObserver' in window) lc.observe(new ResizeObserver(function () { if (!busy) sched(); }), st.parentElement);
    if (!('IntersectionObserver' in window) || reduced.matches) return lc.done;
    st.classList.add('wc-anim');
    var inside = false;
    var reset = function () {
      st.classList.add('wc-reset'); st.classList.remove('is-in');
      void st.offsetWidth;
      st.classList.remove('wc-reset');
    };
    lc.observe(new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio >= 0.4) { if (!inside) { inside = true; st.classList.add('is-in'); } }
        else if (!e.isIntersecting && inside) { inside = false; reset(); }
      });
    }, { threshold: [0, 0.4] }), st);
    return lc.done;
  };

  // Export hair-texture.js: hair-type tabs (click, hover on fine pointers, arrow keys) driving the HairSequence
  // canvas engine. The engine (assets/hair/) is not in the export; without it the stage stays hidden and the
  // tabs and rows still work.
  inits.routine = function (root) {
    var lc = lifecycle();
    var stage = root.querySelector('.ht-stage');
    var canvas = stage && stage.querySelector('.hair-canvas');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ht-card'));
    if (!cards.length) return lc.done;
    var tabs = cards.map(function (c) { return c.querySelector('.ht-tab'); });
    var keys = cards.map(function (c) { return c.dataset.type; });
    var names = cards.map(function (c) { return c.dataset.label; });
    var list = root.querySelector('.ht-grid');
    var live = root.querySelector('.ht-live');
    var prefix = stage ? stage.getAttribute('aria-label').split(':')[0] : '';
    var hov = window.matchMedia('(hover:hover) and (pointer:fine)');
    var hair = null; var sel = 0; var inView = false; var interacted = false; var idle = 0; var hoverT = 0;
    var count = cards.length;

    function ui(i, announce) {
      sel = i;
      cards.forEach(function (c, k) {
        var on = k === i;
        c.classList.toggle('is-on', on);
        tabs[k].setAttribute('aria-selected', on);
        tabs[k].tabIndex = on ? 0 : -1;
      });
      if (stage) stage.setAttribute('aria-label', prefix + ': ' + names[i]);
      if (announce && live) live.textContent = names[i] + ' routine selected.';
    }
    function schedule() {
      clearTimeout(idle);
      if (interacted || !inView || !hair) return;
      idle = setTimeout(function () {
        if (interacted || !inView) return;
        go((sel + 1) % count, false);
        schedule();
      }, 4000);
    }
    function go(i, user) {
      if (user) { interacted = true; clearTimeout(idle); }
      ui(i, user);
      if (hair) hair.goTo(keys[i]);
    }
    function init() {
      if (hair || !canvas || typeof window.HairSequence !== 'function') return;
      hair = window.HairSequence({ canvas: canvas, base: root.dataset.hairBase || 'assets/hair/', initial: keys[sel] });
      hair.addEventListener('change', function (e) {
        var i = keys.indexOf(e.detail.type);
        if (i >= 0 && i !== sel) ui(i, false);
      });
      hair.addEventListener('ready', function () {
        stage.classList.add('is-ready');
        if (hair.type !== keys[sel]) hair.goTo(keys[sel]);
        schedule();
      });
    }
    cards.forEach(function (c, i) {
      lc.on(c, 'click', function (e) {
        if (e.target.closest('.hair-rows')) return;
        go(i, true);
      });
      lc.on(c, 'mouseenter', function () {
        if (!hov.matches) return;
        clearTimeout(hoverT);
        hoverT = setTimeout(function () { if (i !== sel) go(i, true); }, 150);
      });
      lc.on(c, 'mouseleave', function () { clearTimeout(hoverT); });
    });
    lc.on(list, 'keydown', function (e) {
      var k = tabs.indexOf(document.activeElement);
      if (k < 0) return;
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (k + 1) % count;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (k + count - 1) % count;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = count - 1;
      if (n === null) return;
      e.preventDefault();
      tabs[n].focus();
      go(n, true);
    });
    if ('IntersectionObserver' in window) {
      lc.observe(new IntersectionObserver(function (es) { if (es[0].isIntersecting) init(); }, { rootMargin: '400px 0px' }), root);
      if (stage) lc.observe(new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (inView) schedule(); else clearTimeout(idle);
      }, { threshold: 0.25 }), stage);
    } else { inView = true; init(); }
    ui(0, false);
    lc.add(function () { clearTimeout(idle); clearTimeout(hoverT); });
    return lc.done;
  };

  // Export app.js carousel(): dots are reachable scroll positions; keyboard arrows; mouse drag-to-scroll (a drag
  // never fires a click). Export responsive.js 2b: a prev / "n of N" / next pager when the dots do not fit.
  function carousel(root, lc) {
    var track = root.querySelector('.horizontal-track');
    var dotsBox = root.querySelector('.carousel-dots');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var wrap = dotsBox && dotsBox.closest('.carousel-dots-wrap');
    var pos = [0]; var first = [0]; var active = 0; var frame = 0;
    var inset = function () { return parseFloat(getComputedStyle(track).paddingLeft) || 0; };
    var label = function (i) { return (slides[i].getAttribute('aria-label') || '').replace(/^\d+ of \d+:\s*/, ''); };

    function update() {
      var x = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      if (max > 0 && x >= max - 2) active = pos.length - 1;
      else {
        var best = 0;
        pos.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(pos[best] - x)) best = i; });
        active = best;
      }
      if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (b, i) { b.setAttribute('aria-pressed', String(active === i)); });
      frame = 0;
    }
    function go(i) {
      i = Math.max(0, Math.min(pos.length - 1, i));
      track.scrollTo({ left: pos[i], behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    function measure() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var tl = track.getBoundingClientRect().left;
      var ins = inset();
      var p = []; var f = [];
      slides.forEach(function (sl, i) {
        var x = Math.min(max, Math.max(0, Math.round(sl.getBoundingClientRect().left - tl + track.scrollLeft - ins)));
        if (!p.length || x - p[p.length - 1] > 2) { p.push(x); f.push(i); }
      });
      if (max > 2 && max - p[p.length - 1] > 2) { p.push(max); f.push(slides.length - 1); }
      pos = p; first = f;
      if (dotsBox && dotsBox.children.length !== pos.length) {
        dotsBox.textContent = '';
        pos.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.dataset.slide = i;
          b.setAttribute('aria-pressed', 'false');
          b.addEventListener('click', function () { go(i); });
          dotsBox.appendChild(b);
        });
      }
      if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (b, i) {
        b.setAttribute('aria-label', 'Show ' + label(first[i]) + ', position ' + (i + 1) + ' of ' + pos.length);
      });
      var single = pos.length < 2;
      if (wrap) wrap.hidden = single;
      track.classList.toggle('is-draggable', !single);
      update();
    }
    lc.on(track, 'scroll', function () { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    lc.on(track, 'keydown', function (e) {
      if (e.target !== track) return;
      var n;
      if (e.key === 'ArrowRight') n = active + 1;
      else if (e.key === 'ArrowLeft') n = active - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = pos.length - 1;
      else return;
      e.preventDefault();
      go(n);
    });
    var sx = 0; var sl = 0; var id = null; var moved = false;
    lc.on(track, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || pos.length < 2) return;
      id = e.pointerId; sx = e.clientX; sl = track.scrollLeft; moved = false;
    });
    lc.on(track, 'pointermove', function (e) {
      if (e.pointerId !== id) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) { moved = true; track.setPointerCapture(id); track.classList.add('is-dragging'); }
      if (moved) { e.preventDefault(); track.scrollLeft = sl - dx; }
    });
    var end = function (e) {
      if (e.pointerId !== id) return;
      id = null;
      if (!moved) return;
      track.classList.remove('is-dragging');
      var x = track.scrollLeft;
      var best = 0;
      pos.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(pos[best] - x)) best = i; });
      go(best);
    };
    lc.on(track, 'pointerup', end);
    lc.on(track, 'pointercancel', end);
    lc.on(track, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    lc.on(track, 'dragstart', function (e) { if (pos.length > 1) e.preventDefault(); });
    var t = 0;
    var later = function () { clearTimeout(t); t = setTimeout(measure, 150); };
    lc.add(function () { clearTimeout(t); });
    lc.on(window, 'resize', later);
    lc.on(window, 'orientationchange', later);
    lc.on(window, 'load', later);
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (im) { if (!im.complete) lc.on(im, 'load', later, { once: true }); });
    if ('ResizeObserver' in window) lc.observe(new ResizeObserver(later), track);
    if (document.fonts) document.fonts.ready.then(later);
    measure();

    if (!dotsBox || !wrap) return;
    var pg = document.createElement('div');
    pg.className = 'xt-pager';
    pg.setAttribute('role', 'group');
    pg.setAttribute('aria-label', dotsBox.getAttribute('aria-label') || 'Slides');
    pg.innerHTML = '<button type="button" aria-label="Previous"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"></path></svg></button><span class="xt-pager-n" aria-live="polite"></span><button type="button" aria-label="Next"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"></path></svg></button>';
    wrap.appendChild(pg);
    var btns = pg.querySelectorAll('button');
    var num = pg.querySelector('.xt-pager-n');
    var dot = function (step) {
      var b = Array.prototype.slice.call(dotsBox.children);
      var i = Math.max(0, b.findIndex(function (x) { return x.getAttribute('aria-pressed') === 'true'; }));
      var target = b[i + step];
      if (target) target.click();
    };
    lc.on(btns[0], 'click', function () { dot(-1); });
    lc.on(btns[1], 'click', function () { dot(1); });
    var sync = function () {
      var b = Array.prototype.slice.call(dotsBox.children);
      var n = b.length;
      var i = Math.max(0, b.findIndex(function (x) { return x.getAttribute('aria-pressed') === 'true'; }));
      num.textContent = (i + 1) + ' of ' + n;
      btns[0].disabled = i === 0;
      btns[1].disabled = i >= n - 1;
      if (wrap.dataset.n !== String(n)) wrap.dataset.n = n;
    };
    var mo = new MutationObserver(sync);
    lc.add(function () { mo.disconnect(); pg.remove(); });
    mo.observe(dotsBox, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed'] });
    sync();
  }

  inits.experience = function (root) {
    var lc = lifecycle();
    carousel(root, lc);
    Array.prototype.forEach.call(root.querySelectorAll('.exp-media video'), function (v) { playWhenVisible(v, lc); });
    return lc.done;
  };

  // Export app.js scroll lock: overflow on body; on touch devices pin the body so iOS cannot scroll behind,
  // then restore the exact position.
  var coarse = window.matchMedia('(pointer: coarse)');
  var lockY = 0;
  var locked = false;
  var previousFocus = null;

  function lock() {
    if (locked) return;
    locked = true;
    lockY = window.scrollY;
    document.body.classList.add('modal-open');
    if (coarse.matches) Object.assign(document.body.style, { position: 'fixed', top: -lockY + 'px', left: '0', right: '0' });
  }

  function unlock() {
    if (!locked || document.querySelector('dialog[open]')) return;
    locked = false;
    document.body.classList.remove('modal-open');
    if (document.body.style.position === 'fixed') {
      Object.assign(document.body.style, { position: '', top: '', left: '', right: '' });
      window.scrollTo({ top: lockY, behavior: 'instant' });
    }
  }

  function openDialog(d) {
    previousFocus = document.activeElement;
    lock();
    d.showModal();
    d.querySelector('[data-close]').focus();
  }

  // Export app.js dialog wiring (close button, backdrop click, focus return) and responsive.js bottom sheet
  // (under 768px: drag down from the top of the sheet to close).
  function wireDialog(d, lc) {
    lc.on(d.querySelector('[data-close]'), 'click', function () { d.close(); });
    lc.on(d, 'click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
    });
    lc.on(d, 'close', function () {
      unlock();
      d.style.transform = ''; d.style.transition = '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    });
    var sheetMq = window.matchMedia('(max-width:767px)');
    var y0 = null; var dy = 0; var drag = false;
    lc.on(d, 'touchstart', function (e) {
      if (!sheetMq.matches || d.scrollTop > 0 || e.touches.length > 1) return;
      y0 = e.touches[0].clientY; dy = 0; drag = false;
    }, { passive: true });
    lc.on(d, 'touchmove', function (e) {
      if (y0 == null) return;
      dy = e.touches[0].clientY - y0;
      if (!drag && dy > 10 && d.scrollTop <= 0) { drag = true; d.style.transition = 'none'; }
      if (drag) d.style.transform = 'translateY(' + Math.max(0, dy - 10) + 'px)';
    }, { passive: true });
    var end = function () {
      if (y0 == null) return;
      y0 = null;
      if (!drag) return;
      drag = false;
      d.style.transition = reduced.matches ? 'none' : 'transform .22s cubic-bezier(.22,1,.36,1)';
      if (dy > 90) {
        d.style.transform = 'translateY(100%)';
        lc.timer(setTimeout(function () { d.close(); d.style.transform = ''; d.style.transition = ''; }, reduced.matches ? 0 : 200));
      } else {
        d.style.transform = '';
        lc.timer(setTimeout(function () { d.style.transition = ''; }, 240));
      }
    };
    lc.on(d, 'touchend', end);
    lc.on(d, 'touchcancel', end);
  }

  // Buy dialog: fills from the clicked set's JSON payload (#sc-set-N), adds to the Shopify cart, then shows
  // the added state with Keep shopping and View cart.
  inits.collection = function (root) {
    var lc = lifecycle();
    var dialog = root.parentElement.querySelector('#buy-dialog');
    if (!dialog) return lc.done;
    var form = dialog.querySelector('#buy-form');
    var submit = dialog.querySelector('#buy-submit');
    var status = dialog.querySelector('#buy-status');
    var freq = dialog.querySelector('#buy-freq');
    var added = dialog.querySelector('#buy-added');
    var addedTitle = dialog.querySelector('#buy-added-title');
    var current = null;
    var busy = false;

    wireDialog(dialog, lc);

    function readSet(n) {
      var node = document.getElementById('sc-set-' + n);
      if (!node) return null;
      try { return JSON.parse(node.textContent); } catch (e) { return null; }
    }

    function mode() {
      return form.querySelector('input[name="buy-mode"]:checked').value;
    }

    function selectedPlan() {
      return current.plans.filter(function (p) { return String(p.id) === freq.value; })[0] || current.plans[0];
    }

    function sync() {
      var isSub = mode() === 'sub';
      freq.disabled = !isSub;
      var plan = selectedPlan();
      var subPrice = dialog.querySelector('#buy-sub-price');
      subPrice.textContent = '';
      if (plan) {
        subPrice.appendChild(document.createTextNode(plan.price + ' · '));
        var save = document.createElement('span');
        save.className = 'buy-save';
        save.textContent = 'Save ' + plan.save + ' (' + plan.savePct + '%)';
        subPrice.appendChild(save);
      }
      submit.disabled = busy || !current.available;
      submit.textContent = !current.available ? submit.dataset.labelSoldout : (isSub ? submit.dataset.labelSub : submit.dataset.labelOnce);
    }

    function open(n) {
      current = readSet(n);
      if (!current) return;
      var img = dialog.querySelector('#buy-img');
      img.src = current.image || 'data:,';
      img.style.visibility = current.image ? '' : 'hidden';
      if (current.image) { img.width = current.imageWidth; img.height = current.imageHeight; }
      img.alt = current.imageAlt || '';
      dialog.querySelector('#buy-eyebrow').textContent = current.eyebrow;
      dialog.querySelector('#buy-title').textContent = current.title;
      dialog.querySelector('#buy-includes').textContent = current.includes ? 'Includes ' + current.includes + '.' : '';
      var buyShip = dialog.querySelector('#buy-ship'); if (buyShip && current.shippingNote) buyShip.textContent = current.shippingNote;
      dialog.querySelector('#buy-once-price').textContent = current.price;
      dialog.querySelector('[data-mode="once"]').hidden = current.requiresPlan;
      dialog.querySelector('[data-mode="sub"]').hidden = !current.plans.length;
      freq.textContent = '';
      current.plans.forEach(function (p) {
        var option = document.createElement('option');
        option.value = p.id;
        option.textContent = p.name;
        freq.appendChild(option);
      });
      form.querySelector('input[value="' + (current.requiresPlan && current.plans.length ? 'sub' : 'once') + '"]').checked = true;
      status.textContent = '';
      added.hidden = true;
      dialog.classList.remove('is-added');
      sync();
      openDialog(dialog);
    }

    lc.on(document, 'click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-buy]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger.getAttribute('data-buy'));
    });
    lc.on(form, 'change', function (e) {
      if (e.target.name === 'buy-mode' || e.target === freq) sync();
    });
    lc.on(form, 'submit', function (e) {
      e.preventDefault();
      if (!current || busy || !current.available) return;
      var set = current;
      var m = mode();
      busy = true;
      submit.disabled = true;
      status.textContent = '';
      buy.add(set, m, m === 'sub' ? freq.value : null).then(function (result) {
        busy = false;
        sync();
        if (current.variantId !== set.variantId) return;
        if (result.state === 'error') { status.textContent = result.message; return; }
        addedTitle.textContent = current.title;
        dialog.classList.add('is-added');
        added.hidden = false;
        addedTitle.focus();
      });
    });
    lc.on(dialog.querySelector('[data-keep-shopping]'), 'click', function () { dialog.close(); });
    return lc.done;
  };

  // Page-level behaviours (run once): header offset, in-page anchors, reading progress, video guard.
  function page() {
    var main = document.getElementById('root');
    if (!main) return;

    // Export app.js hdr(): the fixed header's bottom edge, used as scroll padding for #anchor jumps.
    var header = function () {
      var bottom = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.v20-topbar, .v20-nav'), function (el) {
        bottom = Math.max(bottom, Math.round(el.getBoundingClientRect().bottom));
      });
      return bottom;
    };
    var setHeader = function () { var h = header(); if (h) document.documentElement.style.scrollPaddingTop = h + 10 + 'px'; };
    setHeader();
    window.addEventListener('resize', setHeader);

    // Export page-guard.js: smooth in-page anchors offset by the fixed header plus the target scroll-margin-top (10px if none).
    main.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
      var id = a.getAttribute('href').slice(1);
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var gap = parseFloat(getComputedStyle(el).scrollMarginTop) || 10;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - header() - gap, behavior: reduced.matches ? 'auto' : 'smooth' });
      history.pushState(null, '', '#' + id);
    });

    // Export app.js onScroll(): reading progress bar under the nav.
    var nav = document.querySelector('.v20-nav');
    if (nav) {
      var bar = document.createElement('div');
      bar.className = 'reading-progress';
      bar.id = 'reading-progress';
      bar.style.cssText = 'position:absolute;left:0;bottom:-1px;height:2px;background:#191817;width:0;pointer-events:none';
      nav.appendChild(bar);
      var queued = false;
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (max > 0 ? Math.min(100, window.scrollY / max * 100) : 0) + '%';
        queued = false;
      };
      window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(onScroll); } }, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    // Export video-guard.js: pause playing videos while the tab is hidden, resume them when it is back.
    var paused = [];
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        paused = Array.prototype.filter.call(main.querySelectorAll('video'), function (v) { return !v.paused; });
        paused.forEach(function (v) { v.pause(); });
      } else {
        if (!reduced.matches) paused.forEach(function (v) { var p = v.play(); if (p) p.catch(function () {}); });
        paused = [];
      }
    });
  }

  var ADD_ERROR = 'Something went wrong. Please try again.';
  var VERIFY_ERROR = 'Unable to verify cart. Please try again.';

  // Cart add for one set, using the theme's cart helpers (assets/subscription-cart.js) like product-form.js.
  // Resolves { state: 'added' | 'already' | 'error', message? }.
  var buy = {
    payload: function (set, mode, planId) {
      var item = { id: set.variantId, quantity: 1 };
      if (mode === 'sub' && planId) item.selling_plan = Number(planId);
      return { items: [item] };
    },
    post: function (set, mode, planId) {
      return window.fetch(window.XtresseGwp.cartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(buy.payload(set, mode, planId))
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) return { state: 'error', message: data.description || data.message || ADD_ERROR };
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sc-landing', productVariantId: set.variantId, cartData: data }); } catch (e) {}
          }
          return { state: 'added' };
        });
      }).catch(function () {
        return { state: 'error', message: ADD_ERROR };
      });
    },
    add: function (set, mode, planId) {
      var gwp = window.XtresseGwp;
      if (mode !== 'sub') return buy.post(set, mode, planId);
      return gwp.fetchCartJson().then(function (cart) {
        return gwp.cartHasSubscription(cart, set.variantId, planId) ? { state: 'already' } : buy.post(set, mode, planId);
      }, function () {
        return { state: 'error', message: VERIFY_ERROR };
      });
    }
  };

  window.ScLanding = { inits: inits, lifecycle: lifecycle, start: start, stop: stop, reduced: reduced, buy: buy };

  function boot() { page(); startAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
